// Utilidades para manejo seguro de autenticación

// Verificar si el token está próximo a expirar (opcional)
export const isTokenExpiringSoon = (token) => {
  if (!token) return true;
  
  try {
    // Decodificar el token JWT (solo la parte del payload)
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    const timeUntilExpiry = payload.exp - currentTime;
    
    // Considerar que expira pronto si faltan menos de 5 minutos
    return timeUntilExpiry < 300;
  } catch (error) {
    console.error('Error decodificando token:', error);
    return true; // Si no se puede decodificar, considerar que expira
  }
};

// Obtener información del usuario desde el token (sin credenciales sensibles)
export const getUserInfoFromToken = (token) => {
  if (!token) return null;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return {
      userId: payload.userId,
      username: payload.username,
      roles: payload.roles,
      exp: payload.exp
    };
  } catch (error) {
    console.error('Error obteniendo info del token:', error);
    return null;
  }
};

// Validar formato de token
export const isValidTokenFormat = (token) => {
  if (!token || typeof token !== 'string') return false;
  
  // Verificar que tenga el formato JWT: header.payload.signature
  const parts = token.split('.');
  return parts.length === 3;
};

// Limpiar datos sensibles del localStorage
export const clearSensitiveData = () => {
  try {
    // Solo limpiar datos de autenticación, no otros datos de la app
    const keysToRemove = [
      'persist:root',
      'auth_token',
      'user_credentials'
    ];
    
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);
    });
  } catch (error) {
    console.error('Error limpiando datos sensibles:', error);
  }
};
